/**
 * Status badge for a human review request. Always carries a text label (not
 * colour alone) for accessibility.
 *
 * @module ReviewStatusBadge
 */
import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ReviewStatus } from '@/lib/humanReviewsApi';

const STATUS_CLASS: Record<ReviewStatus, string> = {
  pending: 'border-amber-300 bg-amber-50 text-amber-700',
  in_progress: 'border-sky-300 bg-sky-50 text-sky-700',
  completed: 'border-emerald-300 bg-emerald-50 text-emerald-700',
  cancelled: 'border-border bg-muted text-muted-foreground',
};

export function ReviewStatusBadge({ status }: { readonly status: ReviewStatus }) {
  const { t } = useTranslation();
  return (
    <Badge
      variant="outline"
      className={cn('font-ui text-[10px] font-semibold uppercase tracking-wider', STATUS_CLASS[status])}
    >
      {t(`humanReview.status.${status}`)}
    </Badge>
  );
}
